"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    "ar": "AR",
    "ai": "AI",
    "vr": "VR",
    "rpg": "RPG",
    "smb": "SMB",
    "envy": "ENVY",
    "omen": "OMEN",
    "hp": "HP",
    "x360": "x360",
    "x-360": "x360",
    "x2": "x2",
    "x-2": "x2",
    "esports": "eSports",
    "cpu": "CPU",
    "pc": "PC",
    "pcs": "PCs",
    "hdd": "HDD",
    "ssd": "SSD",
    "4k": "4K",
    "3d": "3D",
    "ram": "RAM",
    "dram": "DRAM",
    "e-waste": "E-Waste",
    "gpu": "GPU",
    "ml": "ML",
    "saas": "SaaS",
    "daas": "DaaS",
    "mfa": "MFA",
    "rts": "RTS",
    "fps": "FPS",
    "usb": "USB",
    "vpn": "VPN",
    "os": "OS",
    "rdr": "RDR",
    "cod": "CoD",
    "iot": "IoT",
    "ddr4": "DDR4",
    "nlp": "NLP",
    "aio": "AiO",
    "at": "at",
    "hdmi": "HDMI",
    "av": "AV",
    "faqs": "FAQs",
    "tos": "To's",
    "of": "of",
    "as": "as",
    "a": "a",
    "in": "in",
    "mfp": "MFP",
    "pubg": "PUBG",
    "rdr2": "RDR2",
    "sff": "SFF",
    "all-in-one": "All-in-One",
    "allinone": "ALL-IN-ONE",
    "chargersadapters": "CHARGERS/ADAPTERS",
    "care-packswarranties": "CARE PACKS/WARRANTIES",
    "printersscanners-accessories": "PRINTERS-SCANNERS ACCESSORIES",
    "printersscanners": "PRINTERS-SCANNERS",
    "officejet": "OfficeJet",
    "laserjet": "LaserJet",
    "deskjet": "DeskJet",
    "prodesk": "ProDesk",
    "elitedesk": "EliteDesk",
    "proone": "ProOne",
    "eliteone": "EliteOne",
    "probook": "ProBook",
    "elitebook": "EliteBook",
    "zbook": "ZBook",
    "hd": "HD",
    "uhd": "UHD",
    "fhd": "FHD",
    "8k": "8K",
    "pro": "Pro",
    "11t": "11t",
    "12t": "12t",
    "13t": "13t",
    "14t": "14t",
    "15t": "15t",
    "17t": "17t",
    "11T": "11t",
    "12T": "12t",
    "13T": "13t",
    "14T": "14t",
    "15T": "15t",
    "17T": "17t",
    "2in1": "2-in-1",
    "2-in-1": "2-in-1",
    "for": "for",
    "i3": "i3",
    "i5": "i5",
    "i7": "i7",
    "I3": "i3",
    "I5": "i5",
    "I7": "i7"
};